import { type HeadFC, type PageProps } from 'gatsby';
import { type FC } from 'react';

import { SEO } from '@/components/common';
import type { PageContextType } from '@/types/custom-types';

const NotFoundPage: FC<PageProps> = () => (
  <>
    <h1>404: Not Found</h1>
  </>
);

export const Head: HeadFC<null, PageContextType> = ({
  location: { pathname },
  pageContext: { language },
}) => <SEO pathname={pathname} language={language} title="404: Not found" />;

export default NotFoundPage;
